import { cellText } from '@/lib/daily-reports/cells';

import { columnIndex, findHeaderRowIndex } from './headers';
import type { EatonCoverageRow } from './types';

function coverageFromRow(
  header: unknown[],
  row: unknown[],
  sourceSheet: string,
): EatonCoverageRow | null {
  const spaId = cellText(row[columnIndex(header, 'PRICE LIST ID')]);
  const customerNumber = cellText(row[columnIndex(header, 'CUSTOMER NUMBER')]);
  if (spaId === '' || customerNumber === '') return null;
  return {
    spaId,
    spaDescription: cellText(
      row[columnIndex(header, 'PRICE LIST DESCRIPTION')],
    ),
    customerNumber,
    customerName: cellText(row[columnIndex(header, 'CUSTOMER NAME')]),
    region: cellText(row[columnIndex(header, 'REGION')]),
    priceListType: cellText(row[columnIndex(header, 'PRICE LIST TYPE')]),
    status: cellText(row[columnIndex(header, 'PRICE LIST ID STATUS')]),
    sourceSheet,
  };
}

/** One customer assignment per SPA from a Westburne master / regional list. */
export function parseCoverageSheet(
  rows: unknown[][],
  sourceSheet: string,
): EatonCoverageRow[] {
  const headerIndex = findHeaderRowIndex(rows, 'PRICE LIST ID');
  if (headerIndex < 0) return [];
  const header = rows[headerIndex];
  if (!header) return [];
  const parsed: EatonCoverageRow[] = [];
  for (const row of rows.slice(headerIndex + 1)) {
    const coverage = coverageFromRow(header, row, sourceSheet);
    if (coverage) parsed.push(coverage);
  }
  return parsed;
}

export function dedupeCoverage(
  rows: readonly EatonCoverageRow[],
): EatonCoverageRow[] {
  const byKey = new Map<string, EatonCoverageRow>();
  for (const row of rows) {
    byKey.set(`${row.spaId}|${row.customerNumber}`, row);
  }
  return [...byKey.values()];
}
